module.exports = __webpack_public_path__ + "static/media/eatOut.ecd24839.svg";